/** Official festival support inbox (footer, confirmations, legal contacts). */
export const SUPPORT_EMAIL = 'help@aztangofest.com';
